<template>
	<div class="text-uppercase">
		<!-- error messages -->
		<div class="alert alert-danger" v-if="errorMessage || podeAgendarMsg">
			<strong>{{ errorMessage || podeAgendarMsg }}</strong>
		</div>

		<div class="panel panel-custom">
			<div class="panel-heading">
				<i class="fa fa-calendar pull-right" style="margin-top:5px;"></i>
				<strong>AGENDAMENTO</strong>
			</div>
			<div class="panel-body">
				<form @submit.prevent="preSave">
					<fieldset :disabled="podeAgendarMsg">
						<v-input
							type="tel"
							label="DATA"
							:value="data"
							disabled
						></v-input>

						<v-select
							label="ASSUNTO"
							v-model="form.assuntoAgendamento"
							option-text="nome"
							:options="assuntosAgendamento"
						></v-select>

						<v-textarea
							label="DESCRIÇÃO DO ASSUNTO"
							v-model="form.descricaoAssunto"
							rows="3"
							maxlength="200"
							:error-message="validate('isNotBlank', form.descricaoAssunto, 'Preenchimento obrigatório')"
						></v-textarea>

						<template v-if="confirming">
							<form @submit.prevent="save" class="form-horizontal">
								<div class="form-group" style="margin-bottom:0;">
									<div class="col-xs-6">
										<label class="text-uppercase" style="line-height:35px;margin-bottom:0px">Confirma?</label>
									</div>
									<div class="col-xs-6 text-right">
										<button type="button" class="btn btn-danger" @click="confirming = false">NÃO</button>
										<button type="submit" class="btn btn-success">SIM</button>
									</div>
								</div>
							</form>
						</template>
						<template v-else>
							<button type="submit" class="btn btn-success pull-right">SALVAR</button>
						</template>
					</fieldset>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery';
	import moment from 'moment';
	import Form from 'helpers/form';
	import Agenda from 'models/agenda';
	import rules from 'helpers/validationRules';

	export default {
		data() {
			let slot = this.$route.query.slot;

			return {
				confirming: false,
				validating: false,
				errorMessage: '',
				assuntosAgendamento: '',
				podeAgendarMsg: '',

				form: new Form({
					horaAgenda: {
						id: slot
					},

					assuntoAgendamento: {
						id: ''
					},

					descricaoAssunto: ''
				})
			};
		},

		async created() {
			this.assuntosAgendamento = await Agenda.getAssuntosAgendamento();
			this.podeAgendarMsg = await Agenda.municipePodeAgendar();
		},

		computed: {
			data() {
				return moment(this.$route.params.data, 'DD-MM-YYYY-HH:mm:ss').format('DD [de] MMMM [de] YYYY HH:mm');
			}
		},

		methods: {
			validate(rule, value, arg, message) {
				if (message === undefined) {
					message = arg;
				}

				if (this.validating) {
					return rules[rule](value, arg) ? '' : message;
				}
			},

			hasValidationErrors() {
				let fields = $('.has-error');

				return fields.length > 0;
			},

			preSave() {
				this.validating = true;
				this.errorMessage = '';

				this.$nextTick(() => {
					if (this.hasValidationErrors() === false) {
						this.confirming = true;
					} else {
						let firstErrorField = $('.has-error:first');

						window.scrollTo(0, firstErrorField.position().top);
					}
				});
			},

			save() {
				let url = `${Config.BASE_URL}/agenda`;

				this.validating = false;
				this.confirming = false;

				this.form.save(url)
					.then(() => {
						this.$router.push('/agendamentos');
					})
					.catch(error => {
						this.errorMessage = error.responseJSON.message || error.responseJSON.errorMessage;

						window.scrollTo(0, 0);

						setTimeout(() => {
							this.errorMessage = '';
						}, 5000);
					});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// form.vue?b64d5fac